import * as React from "react"
const Fire = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ? props.width : 13}
    height={props.height ? props.height : 15}
    fill="none"
    {...props}
  >
    <path
      fill="#BDDEFF"
      fillOpacity={1}
      d="M5.264.035a.5.5 0 0 1 .442.037c2.844 1.71 5.471 4.632 6.332 7.449.434 1.42.432 2.865-.29 4.106-.723 1.24-2.107 2.172-4.225 2.692a.5.5 0 0 1-.494-.816c.866-.983 1.631-2.131 1.743-3.34.085-.921-.204-1.965-1.312-3.074.008 1.18-.447 2.164-.905 2.727a.5.5 0 0 1-.878-.218c-.184-.916-.704-1.32-1.258-1.603-.038.78-.378 1.342-.626 1.75-.07.116-.133.22-.179.312-.737 1.474.155 2.544.773 3.285l.146.175a.5.5 0 0 1-.562.785c-1.91-.71-3.26-2.04-3.76-3.663-.503-1.633-.117-3.472 1.27-5.127.444-.53.833-.97 1.175-1.358C3.86 2.79 4.49 2.077 4.967.366a.5.5 0 0 1 .297-.33Z"
    />
  </svg>
)
export default Fire
